function formatPhoneNumber(phone_number) {
    if (phone_number) {
        phone_number = phone_number.replace("+31", "0");
        phone_number = phone_number.match(/.{1,2}/g);
        phone_number = phone_number.join(" ");

        if (!phone_number.startsWith("06")) {
            // prettier-ignore
            phone_number = `(${phone_number.substr(0,5).replace(' ', '')}) ${phone_number.substr(5, 10)}`;
        }
    }

    return phone_number;
}

function formatZipcode(zip_code) {
    if (zip_code) {
        return zip_code.substr(0, 4) + " " + zip_code.substr(4, 6);
    }

    return zip_code;
}

function formatUrl(url) {
    if (url) {
        return url
            .replace("https://", "")
            .replace("http://", "")
            .replace("www.", "");
    }

    return url;
}

export { formatPhoneNumber, formatZipcode, formatUrl };
